export default {
  functionKey: "REMPLACER",
  title: "REMPLACER",
  group: "Texte",
  origin: [],
  target: [],
  arguments: [],
  maxArguments: 3,
  requiredArguments: [
    { argumentKey: "Start",  name: "Position de départ" },
    { argumentKey: "Length", name: "Nombre de caractères" },
    { argumentKey: "New",    name: "Nouveau texte", empty: true }
  ],
  expectedArguments: [
    { name: "Position de départ",  argumentKey: "Start",  single: true, initialValue: "0" },
    { name: "Nombre de caractères", argumentKey: "Length", single: true, initialValue: "1" },
    { name: "Nouveau texte",       argumentKey: "New",    single: true, initialValue: "", empty: true }
  ],
  description: "Remplace des caractères à partir d'une position. (Ex: REMPLACER('helloworld', 0, 5, 'bye') -> 'byeworld')",
  isStarred: false,

  generate(destination, origin, args, isArgumentCol) {
    const start  = args[0] ?? "0";
    const length = args[1] ?? "1";
    const newVal = args[2] ?? "''";
    const code = `${destination} = ${origin}.substring(0, ${start}) + ${newVal} + ${origin}.substring(Number(${start}) + Number(${length}));`;
    return { displayCode: code, safeCode: code };
  }
}
